import Layout from "../../../components/Layout/Layout";
import CustomerFilter from "../../../components/CDP/Customers/CustomerFilter";
import CustomerListTable from "../../../components/CDP/Customers/CustomerListTable";
import { useCustomerFilters } from "../hooks/useCustomerFilters";

const DEFAULT_FILTERS = {
  searchBy: "id",
  searchTerm: "",
};

export default function CustomersListing() {
  const {
    filters,
    setFilters,
    appliedFilters,
    handleApply,
    handleReset,
  } = useCustomerFilters(DEFAULT_FILTERS);

  return (
    <Layout>
      <div className="min-h-screen p-6">
        <div className="mx-auto max-w-7xl">
          <CustomerFilter
            filters={filters}
            setFilters={setFilters}
            handleApply={handleApply}
            handleReset={handleReset}
          />
          <CustomerListTable filtersdata={appliedFilters} />
        </div>
      </div>
    </Layout>
  );
}
